import React, { useContext, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Box, Button, Divider, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AuthContext } from '../context/AuthContext';

export default function WorkspaceTools({ onWazeSettings, wazeEnabled = false, wazeFilterCount = 0 }) {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const [anchor, setAnchor] = useState(null);
  useEffect(() => { setAnchor(null); }, [user?.id, user?.role, location.pathname]);
  const admin = user?.role?.toLowerCase() === 'admin';
  const item = (to, title, description, Icon) => (
    <MenuItem component={NavLink} to={to} onClick={() => setAnchor(null)} sx={{ minHeight: 60, gap: 1 }}>
      <ListItemIcon><Icon fontSize="small" /></ListItemIcon>
      <ListItemText primary={title} secondary={description} secondaryTypographyProps={{ whiteSpace: 'normal' }} />
    </MenuItem>
  );
  return <>
    <Button color="inherit" aria-label="Workspace tools" aria-haspopup="menu" aria-controls={anchor ? 'workspace-tools' : undefined}
      aria-expanded={Boolean(anchor)} onClick={e => setAnchor(e.currentTarget)}
      startIcon={<GridViewOutlinedIcon />} endIcon={<ExpandMoreIcon />} sx={{ minHeight: 44, textTransform: 'none', fontWeight: 700 }}>
      Tools
    </Button>
    <Menu id="workspace-tools" anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      MenuListProps={{ 'aria-label': 'Workspace tools' }} PaperProps={{ sx: { width: 320, maxWidth: 'calc(100vw - 24px)', mt: 1, borderRadius: 2 } }}>
      <Box sx={{ px: 2, pt: 1, pb: 0.5 }}><Typography variant="overline" color="text.secondary">Your workspace</Typography></Box>
      {onWazeSettings && <MenuItem onClick={() => { setAnchor(null); onWazeSettings(); }} sx={{ minHeight: 60, gap: 1 }}>
        <ListItemIcon><MapOutlinedIcon fontSize="small" /></ListItemIcon>
        <ListItemText primary="Waze" secondary={`${wazeEnabled ? 'On' : 'Off'}${wazeFilterCount > 0 ? ` - ${wazeFilterCount} filters` : ''} - configure alerts and filters`} />
      </MenuItem>}
      {admin && <Divider />}
      {admin && <Box sx={{ px: 2, pt: 1 }}><Typography variant="overline" color="text.secondary">Administration</Typography></Box>}
      {admin && item('/admin-panel', 'Admin Panel', 'Users and system settings', AdminPanelSettingsOutlinedIcon)}
      {admin && item('/admin/archived-calls', 'Archived calls', 'Read retained incident records', Inventory2OutlinedIcon)}
      {admin && item('/admin/camera-imports', 'Camera imports', 'Review camera import recovery', VideocamOutlinedIcon)}
    </Menu>
  </>;
}
